<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kvQ9iS/tc-custom/9780857909756.jpg?1717864812001" alt="This image is the cover for the book Spade Among the Rushes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Spade Among the Rushes
      </h1>
      <p class="bookDescription body article font2">
        <b>The acclaimed author of <i>Highland Homespun</i> recounts her experiences as a croft farmer on the west coast of the Scottish Highlands during WWII.</b><br/><br/> The West Highland peninsula of Moidart, in the isolated coastal region known as the Rough Bounds, is as magical as it is remote. It was here that the celebrated author Margaret Leigh chose to pursue an independent life as a crofting farmer in the 1940s. In Spade Among the Rushes, Leigh vividly recounts her struggles to snatch land back from the wilderness as she attempts to transform a deserted croft into a home.<br/><br/> Although far from the Blitz of the Second World War, the effects of the conflict were felt throughout the Highlands. The rationing of food and vital materials, the battles with bureaucrats who had no understanding of a crofter's needs, and even the appearance of a Nazi mine off the coast, all frustrate Margaret Leigh's efforts. But despite the hardships, the land and the people of the Highlands gave her a contentment she had never known before.<br/><br/> This edition has a new Introduction by Katie Maclean, who knew Margaret Leigh during her time in Moidart.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Margaret Leigh
      </h2>
      
      <p class="authorDescription body article">Margaret Leigh was the author of Driftwood and Tangle, Spade Among the Rushes, Highland Homespun, Harvest of the Moor and MyKingdom for a Horse. She was born in London in 1894, the cousin of novelist Dorothy L. Sayers and the daughter of an Oxford don. Herchildhood was spent wandering Europe and beyond for her father&rsquo;s health, and following his death she became a governess, teacher anduniversity lecturer. In what would become a life-long habit, Margaret changed tack dramatically and turned to agriculture to support herself andher mother, studying the subject and working farms and crofts, most notably in the north west of Scotland. She died in 1973.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?095999de